import PosaRedeemActions from '../actions/PosaRedeemActions';
import Url from '../constants/Url';
import axios from 'axios';
import {getLocale} from '@epic-core/common';
import root from 'window-or-global';

/**
 * PosaRedeemSource
 */
const PosaRedeemSource = {
  getCmsContent: {
    remote(state) {
      const url = Url().POSA.GET_CMS_CONTENT(getLocale());
      return axios.get(url);
    },
    success: PosaRedeemActions.getCmsContentSuccess,
    error: PosaRedeemActions.getCmsContentFailure,
  },
  validateCode: {
    remote(state, code) {
      const url = Url().POSA.GET_CARD_STATUS(getLocale());
      return axios.post(url, {code});
    },
    success: PosaRedeemActions.validateCodeSuccess,
    error: PosaRedeemActions.validateCodeFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
  redeemCode: {
    remote(state, code, payload) {
      const url = Url().POSA.REDEEM_CARD(getLocale());
      return axios.post(url, {code, ...payload});
    },
    success: PosaRedeemActions.redeemCodeSuccess,
    error: PosaRedeemActions.redeemCodeFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
};

export default PosaRedeemSource;
